import React from 'react';

const ErrorFilled = ({ 
  width = 16, 
  height = 16, 
  fill = "#CC0000", 
  className = "",
  ...props 
}) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 16 16" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path 
        d="M7.9987 11.332C8.18759 11.332 8.34592 11.2681 8.4737 11.1404C8.60148 11.0126 8.66536 10.8543 8.66536 10.6654C8.66536 10.4765 8.60148 10.3181 8.4737 10.1904C8.34592 10.0626 8.18759 9.9987 7.9987 9.9987C7.80981 9.9987 7.65148 10.0626 7.5237 10.1904C7.39592 10.3181 7.33203 10.4765 7.33203 10.6654C7.33203 10.8543 7.39592 11.0126 7.5237 11.1404C7.65148 11.2681 7.80981 11.332 7.9987 11.332ZM7.33203 8.66536H8.66536V4.66536H7.33203V8.66536ZM7.9987 14.6654C7.07648 14.6654 6.20981 14.4904 5.3987 14.1404C4.58759 13.7904 3.88203 13.3154 3.28203 12.7154C2.68203 12.1154 2.20703 11.4098 1.85703 10.5987C1.50703 9.78759 1.33203 8.92092 1.33203 7.9987C1.33203 7.07648 1.50703 6.20981 1.85703 5.3987C2.20703 4.58759 2.68203 3.88203 3.28203 3.28203C3.88203 2.68203 4.58759 2.20703 5.3987 1.85703C6.20981 1.50703 7.07648 1.33203 7.9987 1.33203C8.92092 1.33203 9.78759 1.50703 10.5987 1.85703C11.4098 2.20703 12.1154 2.68203 12.7154 3.28203C13.3154 3.88203 13.7904 4.58759 14.1404 5.3987C14.4904 6.20981 14.6654 7.07648 14.6654 7.9987C14.6654 8.92092 14.4904 9.78759 14.1404 10.5987C13.7904 11.4098 13.3154 12.1154 12.7154 12.7154C12.1154 13.3154 11.4098 13.7904 10.5987 14.1404C9.78759 14.4904 8.92092 14.6654 7.9987 14.6654Z" 
        fill={fill}
      />
    </svg>
  );
};

export default ErrorFilled;
